module.exports = __webpack_public_path__ + "static/media/logout.a9c7eff2.svg";